import { createContext, useContext } from 'react';

export const LoginJoinModalContext = createContext({
  modal: undefined as 'login' | 'join' | undefined,
  setModal: undefined as undefined | ((modal?: 'login' | 'join') => void),
});
export const useLoginJoinModalContext = () => useContext(LoginJoinModalContext);
